<template>
    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="11.649" height="11.649" viewBox="0 0 11.649 11.649">
        <path id="Union_1" data-name="Union 1" d="M5.325-4700.351v-5.325H0v-1H5.325V-4712h1v5.325h5.325v1H6.324v5.325Z" transform="translate(0 4712)"/>
    </svg>
</template>

<script>
export default {
    name: "IconPlus"
}
</script>
